// extracted by mini-css-extract-plugin
export var addButton = "_3v-d";
export var bullets = "_3v-e";
export var compact = "_3v-2";
export var container = "_3v-j";
export var extendedWarrantyModal = "_3v-f";
export var learn = "_3v-l";
export var learnMore = "_3v-g";
export var offeringOption = "_3v-3";
export var offeringPrice = "_3v-8";
export var offeringSubtitle = "_3v-7";
export var offeringTitle = "_3v-6";
export var offeringsContainer = "_3v-0";
export var pdpTilesBackground = "_3v-n";
export var plan = "_3v-m";
export var regular = "_3v-1";
export var remove = "_3v-k";
export var seeDetailsIcon = "_3v-i";
export var seeDetailsLink = "_3v-h";
export var selectedOption = "_3v-4";
export var shieldIcon = "_3v-b";
export var shieldIconCompact = "_3v-c";
export var subtitle = "_3v-a";
export var title = "_3v-9";
export var unselectedOption = "_3v-5";